import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        position:'relative',
        bottom: 0,
        zIndex: 1200, 
        marginTop:'100px'
    },
    horizontalLine: {
        display: 'flex',
        height: 8
    },
    color3: {
        flexGrow: 1,
        backgroundColor: "#009EE2"
    },
    color2: {
        flexGrow: 1,
        backgroundColor: "#CE1537"
    },
    color1: {
        flexGrow: 1,
        backgroundColor: "#F4C000"
    },
    muni: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: 86,
        backgroundColor: '#efefef',
        padding: '0 90px 0 100px'
    },
    escudoImg: {
        width: 68,
        height: 57
    },
    [theme.breakpoints.down('sm')]: {
        muni: {
            padding: '0 16px 0 10px'
        }
    },
    logoImg: {
        width: 205,
        height: 57
    },
    separador: {
        width: 1,
        height: 40,
        marginLeft: 15,
        marginRight: 15,
        backgroundColor: "#004F9F"
    },
})